import script from "./popupStatement.vue?vue&type=script&setup=true&lang=js"
export * from "./popupStatement.vue?vue&type=script&setup=true&lang=js"

import "./popupStatement.vue?vue&type=style&index=0&id=9eec42fa&lang=less"

const __exports__ = script;

export default __exports__